<script setup>
  import {ref, watch} from "vue";

  import {MedCheckbox} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentTableRowCheckbox",
  });

  const props = defineProps({
    selectedRows: {
      type: Array,
      required: true,
    },
    rowKey: {
      type: String,
      required: true,
    },
  });

  const emit = defineEmits(["update:selectedRows"]);

  const isChecked = ref(props.selectedRows.includes(props.rowKey));

  watch(
    () => props.selectedRows,
    (newSelectedRows) => {
      isChecked.value = newSelectedRows.includes(props.rowKey);
    },
  );

  watch(isChecked, (newCheckedState) => {
    let newSelectedRows = [...props.selectedRows];

    if (newCheckedState) {
      if (newSelectedRows.includes(props.rowKey)) {
        // rowKey is already contained, do not emit update
        return;
      }
      newSelectedRows.push(props.rowKey);
    } else {
      newSelectedRows = newSelectedRows.filter((key) => key !== props.rowKey);
    }

    emit("update:selectedRows", newSelectedRows);
  });
</script>

<template>
  <div class="flex size-6 shrink-0 items-center justify-center stroke-0">
    <MedCheckbox v-model="isChecked" variant="primary" :data-test="getTestId('checkbox')" />
  </div>
</template>
